import {
  UPDATE_SURVEY_TEMPLATE_LIST,
  TOGGLE_SURVEY_TEMPLATE_LIST_LOADING,
  TEMPLATE_SURVEY_LIST_ERROR,
  TEMPLATE_SURVEY_UPDATE_TOTAL_LIST,
  TEMPLATE_SURVEY_EXPORT_CHECKED_IDS
} from '../actions/dataEntrySurveyTemplatesActions';

const initState = {
  name: 'Survey Templates',
  settings: {
    loading: false,
    templateTypes: {},
    questionTypes: {}
  },
  templates: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
    checkedIds: []
  }
};

const dataEntrySurveyTemplatesReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_SURVEY_TEMPLATE_LIST:
      newState.templates.list = action.payload.value;
      break;
    case TOGGLE_SURVEY_TEMPLATE_LIST_LOADING:
      newState.templates.loading = action.payload.value;
      break;
    case TEMPLATE_SURVEY_LIST_ERROR:
      newState.templates.error = action.payload.value;
      break;
    case TEMPLATE_SURVEY_UPDATE_TOTAL_LIST:
      newState.templates.totalRecords = action.payload.value;
      break;
    case TEMPLATE_SURVEY_EXPORT_CHECKED_IDS:
      newState.templates.checkedIds = action.ids;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntrySurveyTemplatesReducer;
